// Filename - useShare.ts
import { useGlobalShare } from "@fuse/sharedComponents/globalShare/GlobalShareContext"

import { DeepLinkPath } from "@fuse/utils/DeviceDection"

const useShare = () => {
  const { share } = useGlobalShare()

  const shareContent = (data: {
    text: string
    url: string
    title: string
    type?: DeepLinkPath
  }) => {
    share(data)
  }

  return shareContent
}

export default useShare
